var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "sidebar", staticClass: "sidebar" },
    [
      _c(
        "v-layout",
        {
          staticStyle: { overflow: "auto" },
          attrs: {
            column: "",
            "align-center": "",
            "fill-height": "",
            "justify-start": ""
          }
        },
        [
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "", color: "primary", "open-delay": "100" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c("WeezieLogo", {
                        staticClass: "back-button mt-1 mb-5",
                        on: { click: _vm.backToHub }
                      })
                    ]
                  }
                }
              ])
            },
            [
              _vm._v(" "),
              _c("span", { staticStyle: { "font-size": "9px" } }, [
                _vm._v(_vm._s(_vm.$t("BackToHub")))
              ])
            ]
          ),
          _vm._v(" "),
          !_vm.isMultiSelect && !_vm.isSplicingTable
            ? _c("sidebar-button", {
                attrs: {
                  buttonName: _vm.$t("Search"),
                  windowName: "search",
                  windowType: "sidebar",
                  icon: "search"
                },
                on: { openSidebar: _vm.toggleSidebar }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMultiSelect && !_vm.isSplicingTable
            ? _c("sidebar-button", {
                attrs: {
                  buttonName: _vm.$tc("Layer", 2),
                  windowName: "layers",
                  windowType: "sidebar",
                  icon: "layers"
                },
                on: { openSidebar: _vm.toggleSidebar }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMultiSelect && !_vm.isSplicingTable
            ? _c("sidebar-button", {
                attrs: {
                  buttonName: _vm.$t("Toolbar"),
                  windowName: "create",
                  windowType: "sidebar",
                  icon: "construction",
                  disabled: _vm.createDisabled
                },
                on: {
                  openSidebar: function($event) {
                    return _vm.toggleTool("create")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMultiSelect && !_vm.isSplicingTable
            ? _c("sidebar-button", {
                attrs: {
                  buttonName: _vm.$t("Select"),
                  windowName: "select",
                  windowType: "sidebar",
                  icon: "mdi-vector-square"
                },
                on: { openSidebar: _vm.toggleSelect }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMultiSelect && !_vm.isSplicingTable
            ? _c("sidebar-button", {
                attrs: {
                  buttonName: _vm.$t("MeasureVerb"),
                  windowName: "measure",
                  windowType: "sidebar",
                  icon: "straighten"
                },
                on: { openSidebar: _vm.toggleMeasurementsToolbar }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMultiSelect && !_vm.isSplicingTable
            ? _c("sidebar-button", {
                attrs: {
                  buttonName: _vm.$t("PathInspector"),
                  windowName: "pathInspector",
                  windowType: "sidebar",
                  icon: "mdi-vector-line"
                },
                on: { openSidebar: _vm.togglePathInspectorToolbar }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasProcessingPermission &&
          !_vm.isMultiSelect &&
          !_vm.isSplicingTable
            ? _c("sidebar-button", {
                attrs: {
                  buttonName: _vm.$t("Processing"),
                  windowName: "processing",
                  windowType: "sidebar",
                  icon: "engineering"
                },
                on: { openSidebar: _vm.toggleProcessing }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMultiSelect && !_vm.isSplicingTable
            ? _c("sidebar-button", {
                attrs: {
                  buttonName: _vm.$t("MapCapture"),
                  windowName: "print",
                  windowType: "toolbar",
                  icon: "photo_camera",
                  disabled: _vm.isToTakePrint
                },
                on: {
                  openSidebar: function($event) {
                    return _vm.togglePrintMap("openPrint", $event)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isBidding && !_vm.isMultiSelect && !_vm.isSplicingTable
            ? _c("sidebar-button", {
                attrs: {
                  buttonName: "Heatmap",
                  windowName: "heatmap",
                  windowType: "toolbar",
                  icon: "landslide"
                },
                on: { openSidebar: _vm.toggleHeatmap }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.workOrderPermissions && !_vm.isMultiSelect && !_vm.isSplicingTable
            ? _c("sidebar-button", {
                attrs: {
                  buttonName: "Work Order",
                  windowName: "workOrder",
                  windowType: "sidebar",
                  icon: "assignment"
                },
                on: { openSidebar: _vm.toggleSelectWorkOrder }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasFibercloudPermission("asset_reservation", "store") &&
          _vm.userHasFibercloudPermission(
            "asset_reservation_object",
            "store"
          ) &&
          _vm.userHasFibercloudPermission(
            "asset_reservation_template",
            "list"
          ) &&
          _vm.userHasModulePermission("module_asset_reservation") &&
          !_vm.isBidding &&
          !_vm.isMultiSelect &&
          !_vm.isSplicingTable
            ? _c("sidebar-button", {
                attrs: {
                  buttonName: _vm.$tc("AssetReservation", 1),
                  windowName: "createAssetReservation",
                  windowType: "sidebar",
                  icon: "mdi-script-text-outline"
                },
                on: { openSidebar: _vm.toggleAssetReservation }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "mb-1", attrs: { "align-end": "", id: "badge" } },
            [
              _c(
                "div",
                [
                  _c(
                    "v-badge",
                    {
                      attrs: {
                        content:
                          _vm.messages.length > 9 ? "9+" : _vm.messages.length,
                        value: _vm.messages.length,
                        color: "accent",
                        tile: "",
                        bordered: "",
                        dark: "",
                        overlap: ""
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: { click: _vm.onNotificationButtonClick }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "#767676", size: "20" } },
                            [_vm._v("notifications_none")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("user-button", {
                    staticStyle: { height: "fit-content" },
                    attrs: {
                      avatarWidth: "40px",
                      avatarHeight: "40px",
                      "name-is-disable": false
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.toggleUserWindow()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("user-window", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.userWindowOpen,
                        expression: "userWindowOpen"
                      }
                    ],
                    attrs: { left: "68px", bottom: "41px" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("notifications-window", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.notificationWindow,
                    expression: "notificationWindow"
                  }
                ],
                attrs: {
                  left: "60px",
                  bottom: "44px",
                  arrowLeft: true,
                  notificationOpen: _vm.notificationWindow
                },
                on: { notifications: _vm.setNotificationNumber }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fadeRightSideBar" } },
        [
          _vm.openSidebar === "search" && _vm.sidebarEnabled
            ? _c("search", { on: { close: _vm.closeSidebar } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fadeRightSideBar" } },
        [
          _c("layers", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.openSidebar === "layers" && _vm.sidebarEnabled,
                expression: "openSidebar === 'layers' && sidebarEnabled"
              }
            ],
            on: { close: _vm.closeSidebar }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1692bcae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1692bcae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/SideBar/SideBar.vue
// module id = null
// module chunks = 